<mat-drawer-container style="height: 100%;width: 100%">

  <mat-drawer-content class="main-container" [ngClass]="backgroundClass">

    <div class="main-top-bar">
      <!-- <div class="main-top-bar-panel"> -->
      <div class="logo">
        <a routerLink="/appointments" [queryParams]="{forDate: currentDate}" target="_blank">
          <img src="assets/images/main-layout/capstone-logo.png" class="logo-fix logo-banner"></a>
      </div>

      <div *ngIf="headerData?.patientData else otherDashboard" class="menu-name header-part-content"
           style="background-color: transparent !important; border: none;  width: 30%;"
           [ngClass]="getPatientStatusClass(headerData.patientData.statusId)">
        <div class="header-title" style="float: left; width: 55%;">
          {{ headerData.headerText }} {{ headerData.patientData.preferredName }}
          <div class="menu-banner-text" *ngIf="headerData.patientData.bannerText">
            {{ headerData.patientData.bannerText }}
          </div>
        </div>
        <div class="menu-id-name" style="background-color: transparent !important; border: none;"
             *ngIf="headerData.patientData.recordId">
          {{ headerData.patientData.recordId }}
        </div>
      </div>
      <ng-template #otherDashboard>
        <div class="menu-name" style="background-color: transparent !important; border: none; float: left; width: 26%;">
          {{ headerData?.headerText }} {{this.subHeader || '' }}<span *ngIf="headerData?.headerText === 'User Dashboard'">{{ headerPageUserName }}</span>
        </div>
      </ng-template>

      <div class="right-menu-bar">
        <div class="item-container">
          <div class="list_action">

            <div class="top-icon">
              <a class="feedback" matTooltip="Refresh cache" style="cursor: pointer"
                 (click)="onRefreshCache()">
                <div class="top-menu-icon">
                  <mat-icon [ngClass]="isRefreshingCache?'rotate':''">refresh</mat-icon>
                </div>
              </a>
            </div>

            <div class="top-icon" *ngIf="isPWAInstallReady">
              <a class="feedback" matTooltip="Add to home Screen" (click)="addToHomeScreen()" style="cursor: pointer">
                <div class="top-menu-icon">
                  <mat-icon>install_desktop</mat-icon>
                </div>
              </a>
            </div>

            <div class="top-icon">
              <a class="feedback" matTooltip="Help Centre" target="_blank" style="cursor:pointer;" href=" https://capstonesystemptyltd.freshdesk.com/support/home">
                <!-- <div class="top-menu-icon"><img src="assets/images/menu/sms_exceptions.svg" /></div> -->
                <mat-icon>help</mat-icon>
              </a>
            </div>

            <div class="top-icon">
              <a class="feedback" matTooltip="SMS Exception"
                 routerLink="/system_management/operations/sms_exception/cancellation">
                <div class="top-menu-icon"><img src="assets/images/menu/sms_exceptions.svg"/></div>
                <!-- <mat-icon>feedback</mat-icon> -->
              </a>
            </div>
            <div class="top-icon">
              <a class="feedback" matTooltip="Waitlist Management"
                 routerLink="/system_management/operations/waitlist-management">
                <div class="top-menu-icon"><img src="assets/images/menu/waitlist.svg"/></div>
                <!-- <mat-icon>format_list_numbered</mat-icon> -->
              </a>
            </div>

            <div class="top-icon-container"
                 *ngIf="isToDoPermissionAllow || isCheckListPermissionAllow || isPatientPermissionAllow">
              <a class="checklist" matTooltip="Checklist" routerLink="/todo/checklist"
                 *ngIf="isCheckListPermissionAllow">
                <div class="top-menu-icon">
                  <img src="assets/images/menu/checklist.svg"/>
                </div>
              </a>
              <span class="notification_count" *ngIf="isCheckListPermissionAllow">
                {{ checklistNotificationsCount }}
              </span>
              <a class="my_action" matTooltip="My Action" routerLink="/todo/my-action" *ngIf="isToDoPermissionAllow">
                <div class="top-menu-icon">
                  <img src="assets/images/menu/my_actions.svg"/>
                </div>
              </a><span class="notification_count" *ngIf="isToDoPermissionAllow">{{ myActionNotificationCount }}</span>
              <a class="user" matTooltip="Patient Actions" routerLink="/todo/patient-actions" [queryParams]="{type:299}"
                 *ngIf="isPatientPermissionAllow">
                <div class="top-menu-icon">
                  <img src="assets/images/menu/patient.svg"/>
                </div>
                <!-- <mat-icon>person</mat-icon> -->
              </a>
              <span class="notification_count" *ngIf="isPatientPermissionAllow">{{ patientActionNotificationCount }}</span>
              <a class="engagement" matTooltip="Engagement" routerLink="/todo/engagement/enquiry" *ngIf="isToDoPermissionAllow">
                <div class="top-menu-icon">
                  <img src="assets/images/menu/Vector.svg"/>
                </div>
              </a><span class="notification_count" *ngIf="isToDoPermissionAllow">{{ engagementNotificationCount }}</span>
            </div>
          </div>

          <div class="user_action">
            <a class="">
              <img src="{{ userImage }}" class="user-img" [matMenuTriggerFor]="menu">
              <!-- <mat-icon  [matMenuTriggerFor]="menu">account_box</mat-icon> -->
            </a>
            <mat-menu #menu="matMenu">
              <button mat-menu-item routerLink="/dashboard">My Dashboard</button>
              <button mat-menu-item (click)="onLogout()">Logout</button>
            </mat-menu>
          </div>
        </div>
      </div>
      <!-- </div> -->
    </div>

    <div class="side-nav-and-content">

      <div class="menu" [ngClass]="hasSubMenu?'menu-expanded':'menu-collapsed'">
        <div class="menu_toggler pointer">
          <div class="oute_item_name">
            <mat-icon (click)="hasSubMenu=!hasSubMenu" title="Toggle menu">menu_open</mat-icon>
          </div>
        </div>
        <div class="menu-panel">

          <div class="menu-item"
               *ngFor="let item of menuItems"
               [matTooltip]="item.displayName"
               matTooltipPosition="right"
               (click)="onMenuClick(item)"
               [ngClass]="{'highlight':item.clicked}">

            <div class="menu-item-icon-name" [ngClass]="{'sub-menu-highlight':(item.clicked && item.subMenu)}">
              <div class="menu-icon"><img [src]="item.iconPath"></div>
              <div class="main-menu-name" *ngIf="hasSubMenu">{{ item.displayName }}</div>
            </div>

            <div class="sub-menu"
                 *ngIf="item.subMenu && item.clicked">
              <div class="column-wrapper" *ngFor="let subMenuItem of item.subMenu">

                <div class="sub-menu-item-icon-name"
                     [ngClass]="subMenuItem.clicked?'sub-menu-highlight':'sub-menu-highlight-empty'"
                     [matTooltip]="subMenuItem.displayName"
                     matTooltipPosition="right"
                     (click)="onSubMenuClick(item,subMenuItem,$event)">
                  <div class="sub-menu-icon"><img [src]="subMenuItem.iconPath"></div>
                  <div class="sub-menu-name" *ngIf="hasSubMenu">{{ subMenuItem.displayName }}</div>
                </div>

                <!--3rd Level MENU START-->
                <div class="column-wrapper"
                     *ngIf="subMenuItem.subMenu && subMenuItem.clicked">
                  <div class="sub-menu-item-icon-name pl-10px"
                       *ngFor="let level3SubMenu of subMenuItem.subMenu"

                       [ngClass]="level3SubMenu.clicked?'sub-menu-highlight':'sub-menu-highlight-empty'"
                       [matTooltip]="level3SubMenu.displayName"
                       matTooltipPosition="right"
                       (click)="onLevel3MenuClick(item,subMenuItem,level3SubMenu,$event)">
                    <div class="sub-menu-icon"><img [src]="level3SubMenu.iconPath"></div>
                    <div class="sub-menu-name" *ngIf="hasSubMenu">{{ level3SubMenu.displayName }}</div>
                  </div>
                </div>
                <!--3rd Level MENU END-->
              </div>
            </div>

          </div>
        </div>
        <div class="outer_item pointer">
          <div class="oute_item_name">
            <mat-icon (click)="openNote()">assignment</mat-icon>
          </div>
        </div>
        <div class="outer_item pointer im-btn-wrapper" *ngIf="isInstantMessagingEnabled" matTooltip="Instant Messaging" matTooltipPosition="right">
          <div class="oute_item_name">
            <mat-icon (click)="openInstantMessaging()">chat</mat-icon>
            <span class="im-unread-badge" *ngIf="chatUnreadCount > 0">{{ chatUnreadCount > 99 ? '99+' : chatUnreadCount }}</span>
          </div>
        </div>
        <div class="version">
          <p class="color-white">V {{ version }}</p>
        </div>
      </div>

      <div class="main-router-outlet-content">
        <router-outlet></router-outlet>
      </div>

    </div>

    <!-- ACS Chat Widget - floating, draggable -->
    <app-chat-widget *ngIf="showChatWidget" [userId]="chatUserId" [userDisplayName]="chatUserName" (minimized)="onChatMinimized()"></app-chat-widget>

  </mat-drawer-content>

  <mat-drawer mode="over" class="search-drawer" [opened]="showSideNav">
    <div class="search-header">
      <span class="search-text">Search</span>
      <span class="search-close" (click)="showSideNav = false"><mat-icon matPrefix>close</mat-icon></span>
    </div>
    <div class="margin-0606">
      <mat-form-field class="full-width" appearance="outline">
        <mat-label>Search</mat-label>
        <mat-icon matPrefix>search</mat-icon>
        <div class="row-wrapper flex-vertical-align-center" matSuffix>
          <mat-spinner diameter="20" *ngIf="searchingPatientRecordsLoading"></mat-spinner>
          <button mat-icon-button aria-label="Clear" (click)="clearFilterText()">
            <mat-icon>close</mat-icon>
          </button>
        </div>

        <input matInput [formControl]="patientAutoCompleteFormCtrl">
        <mat-hint>Enter first 3 char for patient first or/and surname search. <br>Enter $ before Estimate/Invoice number
          search.
        </mat-hint>

      </mat-form-field>
    </div>
    <div class="margin-0606" *ngIf="isPatientPermissionAllow">
      <button mat-raised-button class="full-width btn btn-blue" color="primary" (click)="onAddPatient()">Add patient
      </button>
    </div>

    <div class="patient-search-result">

      <div>
        <div class="mt-10px">
          <div class="title-arrow">
            <span>Patient Results</span><span class="patients-count">&nbsp;({{ patientRemainingCount }})</span>
            <!-- <img src="assets/images/system-mgnt/patient/down_less_than.svg" height="24px" width="24px"> -->
          </div>
          <hr class="dashed-dark">
        </div>
        <div class="user-details" *ngFor="let patient of patientRecords"
        [ngClass]="getPatientStatusClass(patient.StatusId)" (click)="onPatientClick(patient.Id)">
        <div class="user-name">{{ patient.FirstName }} {{ patient.SurName | uppercase }}  
          <span *ngIf="patient.PreferredName" style="font-weight: 400;margin-left:5px">Preferred Name: </span>
          <span *ngIf="patient.PreferredName">"{{ patient.PreferredName }}"</span>
          </div>
        <div class="user-extra-details">{{ getPatientOtherDetails(patient) }}</div>
        <!-- <mat-divider class="mt-1"></mat-divider> -->
       </div>
      </div>


      <div class="load-more full-width mt-5" *ngIf="patientRemainingCount>patientPageSize"
           (click)="onPatientLoadMoreClick()">
        <img src="assets/images/system-mgnt/patient/down_less_than.svg" class="load-more-img">
        <span class="load-more-text">Load More</span>
      </div>

      <div *ngIf="nameSearch">
        <div class="mt-20px">
          <div class="title-arrow">
            <span>Menu Results</span>
            <!-- <span class="patients-count">&nbsp;({{patientRemainingCount}})</span> -->
            <!-- <img src="assets/images/system-mgnt/patient/down_less_than.svg" height="24px" width="24px"> -->
          </div>
          <hr class="dashed-dark">
        </div>

        <div class="user-details" *ngFor="let menu of menuItemsForSearch">

          <div class="menu-item-icon-name">
            <div class="sub-menu-icon"><img [src]="menu.iconPath"></div>
            <a class="user-name filter_menu_item"
               routerLink="{{menu.routeCompletePath}}"
               [matTooltip]="menu.displayName"
               matTooltipPosition="right"
               (click)="filterMenuClick(menu)"
            >{{ menu.displayName }}</a>
          </div>
        </div>
      </div>

      <div class="mt-20px">
        <div class="title-arrow">
          <span>Estimate / Invoice Search <span class="patients-count">&nbsp;Parent - ({{ totalInvoiceItems }})</span> </span>
        </div>
        <hr class="dashed-dark">
      </div>


      <div class="user-details" *ngFor="let item of filteredInvoiceSummaries ">
        <div class="user-name" (click)="navigateToInvoiceSummariesScreen(item)"> {{ item?.InvoiceRecordId }}
          -{{ item?.ChildRecordId }}
        </div>
        <div class="user-extra-details"></div>
      </div>
    </div>

  </mat-drawer>

</mat-drawer-container>
